module.exports = __webpack_public_path__ + "img/Bodice-Front-B8-Gc-Da-Ea.4aaebb23.png";